var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_523_2628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.95947 4.52181C1.95947 4.0688 2.13943 3.63434 2.45976 3.31401C2.78009 2.99368 3.21455 2.81372 3.66757 2.81372H8.79185V18.1866H3.66757C3.21455 18.1866 2.78009 18.0066 2.45976 17.6863C2.13943 17.3659 1.95947 16.9315 1.95947 16.4785V4.52181ZM12.208 2.81372H17.3323C17.7853 2.81372 18.2198 2.99368 18.5401 3.31401C18.8604 3.63434 19.0404 4.0688 19.0404 4.52181V8.79205H12.208V2.81372ZM12.208 12.2082H19.0404V16.4785C19.0404 16.9315 18.8604 17.3659 18.5401 17.6863C18.2198 18.0066 17.7853 18.1866 17.3323 18.1866H12.208V12.2082Z",
    stroke: "#1D2951",
    strokeWidth: 2.13512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_523_2628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4971,
    height: 20.4971,
    fill: "white",
    transform: "translate(0.251465 0.251465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabsIcon);
export default __webpack_public_path__ + "static/media/labsIcon.1084073f5d8e24704ef2c6e8478cabc6.svg";
export { ForwardRef as ReactComponent };